import React, { useEffect } from 'react'
import { useLocation } from 'react-router'
import DeactivateVirtualCardContent from 'src/app/DeactivateVirtualCardContent/DeactivateVirtualCardContent'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { useModalRoute } from 'src/navigation/modalParams'
import { deactivateOverlayLocation } from 'src/navigation/overlayRoutes'
import {
  useQueryVirtualCardDetail,
  useQueryVirtualCardPermissions,
} from 'src/queries/virtualCards.queries'

const DeactivateVirtualCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const location = useLocation()
  const { params } = useModalRoute()
  const virtualCardId = params.id
  const { data: virtualCard } = useQueryVirtualCardDetail({ virtualCardId })

  useQueryVirtualCardPermissions({ virtualCardId })

  useEffect(() => {
    if (virtualCard === undefined) return

    const canonicalDeactivateOverlayLocation = deactivateOverlayLocation(
      virtualCard.id,
      virtualCard.isBillPay,
    )

    if (location.pathname !== canonicalDeactivateOverlayLocation.pathname) {
      dispatch(
        connectedReplace({
          ...canonicalDeactivateOverlayLocation,
          hash: '',
          state: {},
        }),
      )
    }
  }, [location.pathname, virtualCard])

  return <DeactivateVirtualCardContent virtualCard={virtualCard} />
}

export default DeactivateVirtualCard
